<template>
  <div class="correction-container flex flex-col h-screen">
    <div class="border-0 border-b border-gray-200 border-solid">
      <HeaderWrapper
        ref="header-wrapper"
        :show-footer="false"
        :show-filter="false"
        :show-field="true"
      >
        <template #header>
          <div class="p-6 py-5">
            <div
              class="font-bold truncate flex items-center w-full"
              style="font-size: 17px"
            >
              Выгрузки
            </div>
          </div>
        </template>
        <template #field> </template>
      </HeaderWrapper>
    </div>
    <main class="p-6 flex flex-col flex-1 min-h-0 overflow-hidden">
      <el-table :data="exportList" v-loading="loading" border height="100%">
        <el-table-column label="ID" width="300" align="center">
          <template #default="{ row }">
            {{ row._id }}
          </template>
        </el-table-column>
        <el-table-column type="index" label="Имя файла" min-width="250">
          <template #default="{ row }">
            {{ row.filename }}
          </template>
        </el-table-column>
        <el-table-column label="Действия" width="350" align="center">
          <template #default="{ row }">
            <div class="flex justify-center w-full">
              <el-button type="primary" plain @click="exportFile(row)">
                Выгрузить
              </el-button>
              <el-button type="danger" plain @click="deleteFile(row)"
                >Удалить</el-button
              >
            </div>
          </template>
        </el-table-column>
      </el-table>
    </main>
  </div>
</template>

<script>
import {
  deleteCorrectionFile,
  exportCorrectionFile,
  getCorrectionExportList,
} from "@/api/correction";
import HeaderWrapper from "@/components/HeaderWrapper.vue";

export default {
  name: "Correction",
  components: { HeaderWrapper },
  data() {
    return {
      exportList: [],
      loading: false,
    };
  },
  mounted() {
    this.fetchData();
  },
  methods: {
    async fetchData() {
      this.loading = true;
      try {
        const res = await getCorrectionExportList();
        if (res._success) {
          this.exportList = res.data;
        }
      } catch (err) {
        console.error(err);
      } finally {
        this.loading = false;
      }
    },
    getAction(filename) {
      return filename?.toLowerCase().includes("oov") ? "ovv" : "not_ovv";
    },
    downloadFile(filename, fileUrl) {
      fetch(fileUrl)
        .then((response) => response.blob())
        .then((blob) => {
          const url = window.URL.createObjectURL(blob);

          const a = document.createElement("a");
          a.href = url;
          a.download = filename;
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);

          window.URL.revokeObjectURL(url);
        })
        .catch((error) => {
          console.error("Error downloading file:", error);
        });
    },
    async exportFile(row) {
      try {
        this.loading = true;

        const action = this.getAction(row.filename);

        const res = await exportCorrectionFile({
          action,
          filename: row.filename,
        });

        if (res && res.output_path) {
          const fileUrl = `${window.domain}${res.output_path}`;
          this.downloadFile(res.file_name, fileUrl);
        } else {
          this.$message.error("Ошибка выгрузки");
        }
      } catch (err) {
        console.error(err);
        this.$message.error("Ошибка сервера");
      } finally {
        this.loading = false;
      }
    },
    async deleteFile(row) {
      try {
        await this.$confirm(
          `Удалить файл: <span style="font-weight: 600">${row.filename}</span>?`,
          "Подтверждение",
          {
            type: "error",
            dangerouslyUseHTMLString: true,
          }
        );
        this.loading = true;

        const res = await deleteCorrectionFile(row.filename);

        if (res._success) {
          await this.fetchData();
        }
      } catch (err) {
        console.error(err);
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped>
::v-deep(.el-table__header th.el-table__cell) {
  @apply bg-gray-50 text-gray-600;
}
</style>
